/**
 * 使用indexDB 进行页面数据缓存处理
 */
import { EntranceDataType, TerminalType } from '../common/types';
import FrontCacheVersion from '../components/version';
import IndexDB from './indexDB';

type CacheConfig = {
  pageId: string;
  clientType: TerminalType;
};

const getCacheKey = (pageId: string, clientType: TerminalType) => `${pageId}_${clientType}`;

export const getFrontCache = () => {
  const id = window.TEAMS?.currentUser?.id;

  return `${FrontCacheVersion}_${id || 'noId'}`;
};

/**
 * 有些配置用户可以在运行时进行自定义修改，这部分的配置需要实时从后端拿
 * 这里需要将自定义配置和缓存的数据进行合并
 */
export const mergeCustomConfig = (
  custom: EntranceDataType['custom'],
  cacheDatas: EntranceDataType,
) => {
  const { comps = [], name } = custom.page;
  const compMap = comps.reduce((prev, comp) => {
    prev[comp.id] = comp;
    return prev;
  }, {} as Record<string, any>);

  if (comps.length) {
    cacheDatas.page.comps.forEach((comp: any) => {
      const _comp = compMap[comp.id];

      if (_comp) {
        Object.assign(comp, _comp);
      }
    });
  }

  if (name) {
    cacheDatas.page.name = name;
  }

  return cacheDatas;
};

export const mergeRefStyles = (data: EntranceDataType, cacheDatas: EntranceDataType) => {
  if (data?.page?.themeData) {
    cacheDatas.page.themeData = data.page.themeData;
  }
  return cacheDatas;
};

export default class PageCache {
  config: CacheConfig;

  IDB: IndexDB;

  constructor(config: CacheConfig) {
    this.config = config;

    this.IDB = new IndexDB('ebPageCache', [
      { name: 'key', isPrimary: true },
      { name: 'version', unique: true },
      { name: 'languageId', unique: false },
      { name: 'page', unique: false },
      { name: 'frontCacheKey', unique: false },
    ]);
  }

  getCacheKey() {
    const { pageId, clientType } = this.config;

    return getCacheKey(pageId, clientType);
  }

  getCacheDatas = async () => {
    const key = this.getCacheKey();
    const { data } = await this.IDB.get(key);

    // 生成一份数据，防止对数据操作影响原始数据
    return data;
  };

  set(datas: EntranceDataType) {
    const frontCacheKey = getFrontCache();
    const key = this.getCacheKey();

    this.IDB.save(key, { ...datas, key, frontCacheKey });
  }

  removeCacheDatas = (key: string) => {
    this.IDB.remove(key);
  };
}
